<ion-header class="m-mark-location-header">
  <ion-row class="m-mark-location-header__content">
    <div class="back-icon" (click)="handleBack()">
      <ion-img [src]="backArrow"></ion-img>
    </div>
    <div>{{ 'mark_location.heading' | translate }}</div>
  </ion-row>
</ion-header>
<ion-content class="m-mark-location-content">
  <div class="m-mark-location-content__container">
    <ion-row style="height: 100%">
      <ion-col size="3" class="operation-and-issue-listing-col">
        <ion-row
          *ngFor="let item of operationIssueAndMarkedLocationsList; let i = index"
          class="operation-and-issue-listing-col__item operation-and-issue-listing"
          [ngClass]="{ 'operation-and-issue-listing-col__item--active': activeIndex === i }"
          (click)="updateActiveIndex(i)"
        >
          <div class="color-indicator" [ngStyle]="{ background: dotColors[i] }"></div>
          <div class="operation-and-issue-info">
            <div>
              <div class="operation-name">{{ item.operation.name }}</div>
              <div class="issue-name">{{ item.issue.name }}</div>
            </div>
            <div class="dept-name" *ngIf="showDepartmentName">{{ item.operation.department | titlecase }}</div>
          </div>
        </ion-row>
      </ion-col>
      <ion-col size="9" style="height: 100%">
        <ion-row class="click-tracking-wrapper">
          <ion-col size="6">
            <monorepo-click-tracking
              [trackClicks]="frontLocations"
              [imgSrc]="silhouette_front"
              [dotColor]="dotColors[activeIndex]"
              (clickInfo)="handleLocationMarkingOnFront($event)"
            ></monorepo-click-tracking>
          </ion-col>
          <ion-col size="6">
            <monorepo-click-tracking
              [trackClicks]="backLocations"
              [imgSrc]="silhouette_back"
              [dotColor]="dotColors[activeIndex]"
              (clickInfo)="handleLocationMarkingOnBack($event)"
            ></monorepo-click-tracking>
          </ion-col>
        </ion-row>
        <div class="undo-icon" (click)="handleMarkingUndo()">
          <ion-img [src]="undoIcon"></ion-img>
        </div>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
<ion-footer>
  <ion-row class="m-mark-location-footer ion-justify-content-between">
    <ion-col sizeLg="2" sizeMd="4" class="ion-no-padding">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.clearAll' | translate"
        (clickEvent)="handleClearAll()"
      ></ui-custom-button
    ></ion-col>
    <ion-col sizeLg="4" sizeMd="6" class="ion-no-padding" style="text-align: end">
      <ui-custom-button
        *ngIf="isImageCapturingEnabled"
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.addPhoto' | translate"
        style="margin-right: 16px"
        (clickEvent)="takePhoto()"
      ></ui-custom-button>

      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.cancel' | translate"
        style="margin-right: 16px"
        (clickEvent)="handleCancel()"
      ></ui-custom-button>
      <ui-custom-button
        [buttonHeight]="'56px'"
        [btnTxt]="'input_app_common.done' | translate"
        (clickEvent)="handleDone()"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
</ion-footer>
